export default {
  en: {
    pageTitle: 'Address',
    currentAddress: 'Current address',
    inputPlaceholder: 'Search by address',
    searching: 'Searching address...',
    addressNotFound: 'Address not found',
    guestHint: 'The address will be saved to your profile after you sign in.',
    openMap: 'Select address on map',
    mapLocating: 'Getting your location...',
    mapSelectHint: 'Select a point on the map',
    mapResolving: 'Resolving address...',
    mapAddressFallback: 'Move the map to select an address',
    confirmAddress: 'Confirm address',
    outsideDeliveryZone: 'Outside delivery zone',
    locateMe: 'My location',
    locationRequired: 'Allow location access to find your position on the map',
    locationUnavailable: 'Could not determine your location',
    outsideDeliveryArea: 'Delivery is available only in Nha Trang',
    nearbyPlacesLoading: 'Looking for nearby places...',
  },
  ru: {
    pageTitle: 'Адрес',
    currentAddress: 'Текущий адрес',
    inputPlaceholder: 'Искать по адресу',
    searching: 'Ищем адрес...',
    addressNotFound: 'Адрес не найден',
    guestHint: 'После входа адрес сохранится в профиле.',
    openMap: 'Выбрать адрес на карте',
    mapLocating: 'Определяем местоположение...',
    mapSelectHint: 'Выберите точку на карте',
    mapResolving: 'Определяем адрес...',
    mapAddressFallback: 'Переместите карту, чтобы выбрать адрес',
    confirmAddress: 'Подтвердить адрес',
    outsideDeliveryZone: 'Адрес вне зоны доставки',
    locateMe: 'Моё местоположение',
    locationRequired: 'Разрешите геолокацию, чтобы найти вас на карте',
    locationUnavailable: 'Не удалось определить местоположение',
    outsideDeliveryArea: 'Доставка доступна только в Нячанге',
    nearbyPlacesLoading: 'Ищем ближайшие места...',
  },
}
